import { Portal } from '@angular/cdk/portal';
import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, combineLatest, defer, map, Observable } from 'rxjs';

import { MandatorControllerService } from '@bms-client/api';
import { clearCurrentStructureTree, clearCurrentUser, IAppState } from '@bms-client/store';
import { Store } from '@ngrx/store';

import { IconMenuComponent, IIconMenuItem } from '@oc-core/icon-menu';

import { LoadingService } from '../../services/loading.service';
import { PortalService } from '../../services/portal.service';

@Component({
    selector: 'oc-bms-client-default',
    templateUrl: './default.component.html',
    styleUrls: ['./default.component.scss'],
    standalone: false
})
export class DefaultComponent {
    @ViewChild('iconMenu') private readonly iconMenu!: IconMenuComponent;

    private iconMenuItemsSubject = new BehaviorSubject<IIconMenuItem[]>([
        /*{
            id: 'language',
            icon: 'oc-world',
            text: 'Sprache',
        },*/
    ]);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public iconMenuItems$ = this.iconMenuItemsSubject.asObservable();

    public readonly iconDropDownMenu: IIconMenuItem[] = [
        {
            id: 'user',
            icon: '',
            text: '', // special treatment in template
        },
        /*{
            id: 'change-role',
            icon: 'oc-reload',
            text: 'Rolle wechseln',
        },
        {
            id: 'account-settings',
            icon: 'oc-general-settings',
            text: 'Konto',
        },
        {
            id: 'information',
            icon: 'oc-general-info',
            text: 'Information',
        },
        {
            id: 'help',
            icon: 'oc-question-mark',
            text: 'Information',
        },*/
        {
            id: 'logout',
            icon: 'oc-general-logout',
            text: 'Abmelden',
        },
    ];

    public links = [
        {
            icon: 'oc-general-home',
            text: 'Dashboard',
            url: '/dashboard',
        },
        {
            icon: 'oc-structure',
            text: 'Struktur',
            url: '/structure',
        },
        {
            icon: 'oc-department',
            text: 'Fachkapazitäten',
            url: '/capabilities',
        },
        /*{
            icon: 'oc-padlock',
            text: 'Sperrungen',
            url: '/blockages',
        },*/
        {
            icon: 'oc-accompanied',
            text: 'Patientendaten',
            url: '/patient-visits',
        },
        {
            icon: 'oc-tiles',
            text: 'Stammdaten',
            url: '/base-data',
        },
    ];

    private readonly iconMenuOpenSubject$ = new BehaviorSubject<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public readonly iconMenuOpen$ = this.iconMenuOpenSubject$.asObservable();
    public extraButtons$: Observable<Portal<any> | null>;
    public currentUser$ = this.store.select((s) => s.currentUser.userName);
    public mandator$: Observable<string | undefined>;
    public loading$ = this.loader.loading$;

    public constructor(
        private readonly router: Router,
        private portalService: PortalService,
        private readonly store: Store<IAppState>,
        private readonly mandatorService: MandatorControllerService,
        public loader: LoadingService,
    ) {
        this.extraButtons$ = defer(() => this.portalService.extraButtons$).pipe(map((e) => e as Portal<any>));
        this.mandator$ = defer(() =>
            combineLatest([this.mandatorService.getMandateById(), this.store.select((s) => s.currentUser)]).pipe(map(([e]) => e?.mandatorName)),
        );
    }

    public async onMenuItemClick(item: IIconMenuItem) {
        this.iconMenu.toggleMenu();

        if (item.id === 'logout') {
            this.store.dispatch(clearCurrentUser());
            this.store.dispatch(clearCurrentStructureTree());
            await this.router.navigateByUrl('/login');

            return;
        }

        await this.router.navigateByUrl(`/${item.id}`);
    }
}
